import React from "react";
import NavBarComponent from "../../components/navBar/NavBarComponent.js";
import FooterComponent from "../../components/home/FooterComponent.js";
import UsersUsersUsersComponent from "../../components/solutions/cashbackInfo/usersUsersUsers.jsx";
import { Helmet } from "react-helmet";

export default function UsersUsersUsersPage() {
    return (
        <div>
            <div className="updated-page-wrapper">
                <NavBarComponent />

                <Helmet>
                    <title>Users Users Users — How HQ Trivia Built a Massive User Base | Pabloo</title>
                    <meta name="description" content="How HQ Trivia drove 1.2 million live players using cash prizes, referrals, the live feed, and the Hook Model — and what every business can learn from it." />
                    <meta property="og:title" content="Users Users Users — How HQ Trivia Built a Massive User Base" />
                    <meta property="og:description" content="How HQ Trivia drove 1.2 million live players using cash prizes, referrals, the live feed, and the Hook Model." />
                </Helmet>

                <UsersUsersUsersComponent />

                <FooterComponent />
            </div>
        </div>
    );
}
